'use client';

import { Box, CirclePlay, MapPin } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { LucideIcon } from '@/src/components/LucideIcon';
import * as styles from './photoGallery.styles';

type MobileGalleryButtonsProps = {
  hasVideos?: boolean;
  has3dTour?: boolean;
  hasStreetView?: boolean;
  onVideosClick?: () => void;
  on3dTourClick?: () => void;
  onStreetViewClick?: () => void;
};

export const MobileGalleryButtons = ({
  hasVideos,
  has3dTour,
  hasStreetView,
  onVideosClick,
  on3dTourClick,
  onStreetViewClick,
}: MobileGalleryButtonsProps) => {
  const t = useTranslations('hdp');
  if (!hasVideos && !has3dTour && !hasStreetView) return null;

  return (
    <div className={styles.mobileOverlayButtons}>
      {has3dTour && on3dTourClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            on3dTourClick();
          }}
          aria-label={t('view3dTours')}
          data-testid="hero-action-3d-tours"
        >
          <LucideIcon icon={Box} size="sm" />
          {t('threeDTours')}
        </button>
      )}
      {hasVideos && onVideosClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            onVideosClick();
          }}
          aria-label={t('viewVideos')}
          data-testid="hero-action-videos"
        >
          <LucideIcon icon={CirclePlay} size="sm" />
          {t('videos')}
        </button>
      )}
      {hasStreetView && onStreetViewClick && (
        <button
          className={styles.mobileOverlayButton}
          onClick={(e) => {
            e.stopPropagation();
            onStreetViewClick();
          }}
          aria-label={t('viewStreetView')}
          data-testid="hero-action-street-view"
        >
          <LucideIcon icon={MapPin} size="sm" />
          {t('streetView')}
        </button>
      )}
    </div>
  );
};
